import React from "react";
import { sanitizeDescriptionHtml } from "./descriptionEditorConfig";

type Props = {
  content: string;
  className?: string;
};

const RichTextPreview: React.FC<Props> = ({
  content,
  className = "tm-description-text",
}) => {
  if (!content) return null;

  if (!/<[^>]+>/.test(content)) {
    return <span className={className}>{content}</span>;
  }

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizeDescriptionHtml(content) }}
    />
  );
};

export default RichTextPreview;
